import { AlertsRoutes, HealthPhysicsRoutes, HomeRoutes, InventoryRoutes, ModuleRoutes, ReportsRoutes, ScheduleRoutes, SettingsRoutes ,WasteRoutes, ManufacturerPortalRoutes} from "./route.constant";

const homeMenu = {
  title: 'Dashboard',
  name: 'dashboard',
  url: ModuleRoutes.Dashboard.Url,
  src: "menu_home",
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [],
  subMenuHeader: ''
}


const OrgscheduleMenu = {
  src: "menu_patient",
  title: 'Schedule',
  name: 'schedule',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Schedule Procedure',
      name: 'schedule-procedure',
      url: ScheduleRoutes.ScheduleProcedure.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Directory',
      name: 'directory',
      url: ScheduleRoutes.Directory.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Batch Schedule',
      name: 'batch-schedule',
      url: ScheduleRoutes.BatchSchedule.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },{
      title: 'Theranostic',
      name: 'theranostic',
      isMenuVisible: true,
      hasSubMenuItems : true,
      showSubMenuItems : true,
      config: { highlight: false },
      subMenuItems: [
        { title: 'Scheduled Procedures', name: 'theranostic', url: AlertsRoutes.Theranostic.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Written Directive',name: ScheduleRoutes.WrittenDrective.Name, url: ScheduleRoutes.WrittenDrective.Url, isMenuVisible: true, config: { highlight: false }}
      ]
    }
  ],
  subMenuHeader: ''
}

const scheduleMenu = {
  src: "menu_patient",
  title: 'Schedule',
  name: 'schedule',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Schedule Procedure',
      name: 'schedule-procedure',
      url: ScheduleRoutes.ScheduleProcedure.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Directory',
      name: 'directory',
      url: ScheduleRoutes.Directory.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: false,
      config: { highlight: false }
    },
    {
      title: 'Batch Schedule',
      name: 'batch-schedule',
      url: ScheduleRoutes.BatchSchedule.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: false,
      config: { highlight: false }
    },
    {
      title: 'Theranostic',
      name: 'theranostic',
      isMenuVisible: true,
      hasSubMenuItems : true,
      showSubMenuItems : true,
      isSubMenuMobileVisible: false,
      config: { highlight: false },
      subMenuItems: [
        { title: 'Scheduled Procedures', name: 'theranostic', url: AlertsRoutes.Theranostic.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Written Directive',name: 'written-directive'}
      ]
    }
  ],
  subMenuHeader: ''
}

const inventoryMenu = {
  src: "menu_inventory",
  title: 'Inventory',
  name: 'inventory',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Receive Shipment',
      name: 'receive-shipment',
      url: InventoryRoutes.ReceiveShipment.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Manage Inventory',
      name: 'manage-inventory',
      url: InventoryRoutes.ManageInventory.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: false,
      config: { highlight: false }
    },
    {
      title: 'Configure Test',
      name: 'configure-test',
      url: InventoryRoutes.ConfigTest.Url,
      isMenuVisible: true,
      isSubMenuMobileVisible: false,
      config: { highlight: false }
    }
  ],
}

const orginventoryMenu = {
  src: "menu_inventory",
  title: 'Inventory',
  name: 'inventory',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Receive Shipment',
      name: 'receive-shipment',
      url: InventoryRoutes.ReceiveShipment.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Manage Inventory',
      name: 'manage-inventory',
      url: InventoryRoutes.ManageInventory.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Configure Test',
      name: 'configure-test',
      url: InventoryRoutes.ConfigTest.Url,
      isMenuVisible: true,
      config: { highlight: false }
    }
  ],
}

const wasteMenu = {
  src: "menu_waste",
  title: 'Waste',
  name: 'waste',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: false,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Manage Waste',
      name: 'manage-waste',
      url: WasteRoutes.ManageWaste.Url,
      isMenuVisible: true,
      config: { highlight: false }
    }
  ]
}

const healthPhysicsMenu = {
  src: "menu_todo",
  title: 'Health Physics',
  name: 'health-physics',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: false,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Manage Instruments',
      name: 'manage-instruments',
      url: HealthPhysicsRoutes.ManageInstruments.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Manage Survey Groups',
      name: 'manage-survey-groups',
      url: HealthPhysicsRoutes.ManageSurveyGroups.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Manage Other Tasks',
      name: 'manage-other-tasks',
      url: InventoryRoutes.ConfigTest.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'HP History',
      name: 'hp-history',
      url: HealthPhysicsRoutes.HPHistory.Url,
      isMenuVisible: true,
      config: { highlight: false }
    }
  ]
}

const reportsMenu = {
  src: "menu_report",
  title: 'Reports',
  name: 'reports',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: false,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: []
}

export const IdnReports=[
  {
    title: 'Reports',
    name: 'request-reports',
    url: ReportsRoutes.RequestReport.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Download Reports',
    name: 'download-reports',
    url: ReportsRoutes.DownloadReports.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },

  {
    title: 'Document Repository',
    name: 'document-repository',
    url: ReportsRoutes.DocumentRepository.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Invoice',
    name: 'invoice',
    url: ReportsRoutes.Invoice.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Digirad Reports',
    name: 'digirad-reports',
    url:ReportsRoutes.DigiradReports.Url,
    isMenuVisible: true,
    config: { highlight: false }
  }
];

export const NonIdnReports=[
  {
    title: 'Request Reports',
    name: 'request-reports',
    url: ReportsRoutes.RequestReport.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Download Reports',
    name: 'download-reports',
    url: ReportsRoutes.DownloadReports.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Custom Reports',
    name: 'custom-reports',
    url: null,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Document Repository',
    name: 'document-repository',
    url: ReportsRoutes.DocumentRepository.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Invoice',
    name: 'invoice',
    url: ReportsRoutes.Invoice.Url,
    isMenuVisible: true,
    config: { highlight: false }
  },
  {
    title: 'Digirad Reports',
    name: 'digirad-reports',
    url:ReportsRoutes.DigiradReports.Url,
    isMenuVisible: true,
    config: { highlight: false }
  }
];

const alertsMenu = {
  src: "menu_alert",
  title: 'Alerts',
  name: 'alerts',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: false,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Manage Alerts',
      name: 'manage-alerts',
      url: AlertsRoutes.ManageAlerts.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'HL7 Alerts & Messages',
      name: 'hl7-alerts-messages',
      url: AlertsRoutes.HL7Alerts.Url,
      isMenuVisible: true,
      config: { highlight: false }
    },
    {
      title: 'Manufacturer Order Alerts',
      name: 'manufacturer-order-alerts',
      url: AlertsRoutes.ManufacturerOrderAlerts.Url,
      isMenuVisible: true,
      config: { highlight: false }
    }
      ]
}

const settingsMenu = {
  src: "menu_configure",
  title: 'Settings',
  name: 'settings',
  url: null,
  isMenuVisible: true,
  isMenuMobileVisible: false,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [
    {
      title: 'Scheduling',
      name: 'scheduling',
      isMenuVisible: true,
      hasSubMenuItems: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Manage Products', name: 'manage-products', url: SettingsRoutes.ManageProducts.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Manage PO Numbers', name: 'manage-po-numbers', url: SettingsRoutes.ManagePONumbers.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Manage Components', name: 'manage-components', url: SettingsRoutes.ManageComponents.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Manage Procedures', name: 'manage-procedures', url: SettingsRoutes.ManageProcedures.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Patient Classification Master', name: 'patient-class-master', url: SettingsRoutes.PatientClassMaster.Url, isMenuVisible: true, config: { highlight: false } }
      ]
    },
    {
      title: 'Inventory',
      name: 'inventory',
      hasSubMenuItems: true,
      isMenuVisible: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Kit Configuration', name: 'kit-configuration', url: SettingsRoutes.KitConfiguration.Url, isMenuVisible: true, config: { highlight: false } },
      ]
    },
    {
      title: 'Dose Administration',
      name: 'dose-administration',
      isMenuVisible: true,
      hasSubMenuItems: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Site Master', name: 'site-master', url: SettingsRoutes.SiteMaster.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Route Master', name: 'route-master', url: SettingsRoutes.RouteMaster.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Tracking Codes Master', name: 'tracking-codes-master', url: SettingsRoutes.TrackingCodesMaster.Url, isMenuVisible: true, config: { highlight: false } }
      ]
    },
    {
      title: 'Department',
      name: 'department',
      hasSubMenuItems: true,
      isMenuVisible: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Preferences', name: 'preferences', url: SettingsRoutes.Preferences.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'User Management', name: 'user-management', url: SettingsRoutes.UserManagement.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Sharing', name: 'sharing', url: SettingsRoutes.Sharing.Url, isMenuVisible: true, config: { highlight: false } },
      ]
    },
    {
      title: 'Hardware',
      name: 'hardware',
      hasSubMenuItems: true,
      isMenuVisible: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Peripheral Configuration', name: 'peripheral-configuration', url: SettingsRoutes.PeripheralConfig.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Safetrac Configuration', name: 'safetrac-configuration', url: SettingsRoutes.SafetracConfig.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Vendor Barcode Setup', name: 'vendor-barcode-setup', url: SettingsRoutes.VendorBarcodeSetup.Url, isMenuVisible: true, config: { highlight: false } },
      ]
    },
    {
      title: 'Help',
      name: 'help',
      hasSubMenuItems: true,
      isMenuVisible: true,
      showSubMenuItems: false,
      subMenuItems: [
        { title: 'Documents', name: 'documents', url: SettingsRoutes.Documents.Url, isMenuVisible: true, config: { highlight: false } },
        { title: 'Training', name: 'training', url:SettingsRoutes.Training.Url, isMenuVisible: true, config: { highlight: false } },
        { title: '340B Entity Verification', name: '340B-entity-verification', url:HomeRoutes.Home.Url, isMenuVisible: true, config: { highlight: false } },
      ]
    },
  ]
}

const manufacturerPortalMenu = {
  src: "menu_manufacturer",
  title: 'Manufacturer Portal',
  name: 'manufacturer-portal',
  url: ManufacturerPortalRoutes.ManufacturerPortal.Url,
  isMenuVisible: true,
  isMenuMobileVisible: true,
  config: { showSubMenu: false, highlight: false, displayBottom: false },
  subItems: [],
  subMenuHeader: ''
}


/******top navigation********/
export const menuOption = [
  homeMenu, scheduleMenu, inventoryMenu, wasteMenu, healthPhysicsMenu, reportsMenu, alertsMenu, settingsMenu, manufacturerPortalMenu
];

export const orgmenuOption = [
  homeMenu, OrgscheduleMenu, orginventoryMenu, wasteMenu, healthPhysicsMenu, reportsMenu, alertsMenu, settingsMenu, manufacturerPortalMenu
];

